import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HtmlItalic from './icon-html-italic.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HtmlItalic {...validProps} />;
}
SvgComponent.iconName = 'html-italic';

/**
 * @deprecated This is a legacy icon
 */
export const HtmlItalicIcon = svgIconWrapper(SvgComponent);
